import React from 'react';
import { Switch, Route } from 'react-router-dom';
import AsctList from './asct-list';
import AsctForms from './asct-form';
import { paths } from '../../../routes';

const Asct = () => (
  <Switch>
    <Route path={paths.newAsct.path}>
      <AsctForms />
    </Route>
    <Route path={paths.detailAsct.path}>
      <AsctForms />
    </Route>
    <Route path={paths.asct.path}>
      <AsctList />
    </Route>
  </Switch>
);

export default Asct;
